import React from 'react'

interface RowLabelProps {
    data: { key: string, rank: number }[]; 
    fontSize?: number;
}

// TOD: Refactor
const RankLabel: React.FC<RowLabelProps> = ({
    data,
    fontSize = 12,
}) => {
    const keys = data.map(e => e.key); 
    const values = data.map(e => e.rank); 
    const firstValue = values[0]; 

    const cwidth = 30
    const cheight = 15 * keys.length
    const padding = 0;
    const barSpacing = 1;
    const barHeight =
        (cheight - padding * 2 - (keys.length - 1) * barSpacing) / keys.length;

    return (
        <div style={{ width: cwidth, height: cheight, position: 'relative' }}>
            {data.map((e, index) => {
                const isFirstRow = index === 0;
                const difference = firstValue - e.rank;

                return (
                    <div
                        key={e.key}
                        style={{
                            position: 'absolute',
                            top: padding + index * (barHeight + barSpacing),
                            left: 0,
                            height: barHeight,
                            lineHeight: `${barHeight}px`,
                            fontSize: `${fontSize}px`,
                            textAlign: 'right',
                            paddingRight: '10px',
                            color: isFirstRow
                                ? 'black' 
                                : 'rgba(0, 0, 0, 0.5)', 
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {Object.entries(data).length > 1 && <span style={{ marginRight: '5px', backgroundColor: 'gray', opacity: isFirstRow? undefined : 0.4, color: '#fff', width: 15, textAlign: 'center' }}>{e.key}</span>}
                        <span style={{ marginRight: '5px' }}>{e.rank}</span>
                        {!isFirstRow && (
                            <span
                                style={{
                                    color: difference > 0 ? 'green' : 'red', 
                                }}
                            >
                                {difference > 0 ? `+${difference}` : difference}
                            </span>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default RankLabel;
